function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M27.757 25.571H17.158l-1.306-6.19-1.265 6.191H3.728L6.832 6.429H25.17l.017.124zm-10.368-.286h10.04l-2.51-18.57H7.074l-3.011 18.57h10.29l1.493-7.314z" /></svg>;
});